import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the shape of the state
interface AuthState {
  userData: any | null; // Replace `any` with a proper `User` type if available
  token: string | null;
  refreshToken: string | null;
}

// Attempt to load auth state from localStorage
const savedAuth = localStorage.getItem("auth");
const parsedAuth = savedAuth ? (JSON.parse(savedAuth) as AuthState) : null;

const initialState: AuthState = parsedAuth || {
  userData: null,
  token: null,
  refreshToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        userData: any; // Replace `any` with the correct type
        token: string;
        refreshToken: string;
      }>
    ) => {
      const data = action.payload;
      state = data;

      localStorage.setItem("auth", JSON.stringify(data));
    },
    logout: (state) => {
      localStorage.removeItem("auth");
      state = {
        userData: null,
        token: null,
        refreshToken: null,
      };
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
